import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import React from "react";
import ReactDOM from "react-dom";
import InternalMenu from "./InternalMenu";
import LottieAnimation from "./Lottie";

const COMPONENTS = {
  LottieAnimation,
  InternalMenu,
};

function renderComponentInElement(el) {
  var Component = COMPONENTS[el.dataset.component];
  if (!Component) return;
  // get props from elements data attribute, like the post_id
  const props = Object.assign({}, el.dataset);
  ReactDOM.render(<Component {...props} />, el);
}

document
  .querySelectorAll(".__react-component")
  .forEach(renderComponentInElement);

gsap.registerPlugin(ScrollTrigger);

const parallax = document.getElementById("parallaxWrapper");

if (parallax) {
  gsap.to(".parallax-highlight", {
    yPercent: -50,
    // ease: "none",
    opacity: 0,
    scrollTrigger: {
      trigger: "#parallaxWrapper",
      start: "top top",
      end: "bottom top",
      scrub: 1,
    },
  });
  gsap.to(".parallax-image", {
    yPercent: 10,
    scrollTrigger: {
      trigger: "#parallaxWrapper",
      start: "top 10%",
      end: "bottom center",
      scrub: 1,
    },
  });
}

// Authentication
var isAuthenticated = document.cookie.indexOf("authenticated=true") >= 0;

if (isAuthenticated) {
  document.body.classList.add("authenticated");
}
